exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slideout-shopping-basket h2[data-v-4a8295eb] {\n  font-weight: 900;\n  font-size: 1.25rem;\n  line-height: 1.625rem;\n}\n@media screen and (min-width: 1024px) {\n.slideout-shopping-basket h2[data-v-4a8295eb] {\n    font-size: 1.5rem;\n    line-height: 2.3125rem;\n}\n}", ""]);

// exports
